
import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase';
import './PoliciesProcedures.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';

const PoliciesPage = () => {
    const [policies, setPolicies] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pdfLoading, setPdfLoading] = useState(false);

    useEffect(() => {
        if (selectedId) {
            setPdfLoading(true);
            const timer = setTimeout(() => setPdfLoading(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [selectedId]);

    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                const snapshot = await firestore.collection('policies').get();
                const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                list.sort((a, b) => {
                    const titleA = a.title || "";
                    const titleB = b.title || "";
                    return titleA.localeCompare(titleB, undefined, { numeric: true, sensitivity: 'base' });
                });
                setPolicies(list);
            } catch (error) {
                console.error("Error fetching policies:", error);
            }
            setLoading(false);
        };
        fetchPolicies();
    }, []);

    const selectedPolicy = policies.find(p => p.id === selectedId);

    return (
        <div className="pp-page-wrapper">
            <div className="pp-container">
                <h1 className="pp-title">Company Policies</h1>

                <div className="procedures-layout">
                    <div className="procedures-sidebar">
                        <h3>Categories</h3>
                        {loading ? <p>Loading...</p> : (
                            policies.length === 0 ? <p>No policies found.</p> :
                                policies.map((policy) => (
                                    <div
                                        key={policy.id}
                                        className={`sidebar-item ${selectedId === policy.id ? 'active' : ''}`}
                                        onClick={() => setSelectedId(policy.id)}
                                    >
                                        {policy.title || policy.id}
                                    </div>
                                ))
                        )}
                    </div>

                    <div className="procedure-details">
                        {selectedPolicy ? (
                            <>
                                <h2>{selectedPolicy.title}</h2>
                                {selectedPolicy.content && (
                                    <div className="procedure-text">
                                        {selectedPolicy.content}
                                    </div>
                                )}

                                {selectedPolicy.file && (selectedPolicy.file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/) || selectedPolicy.file.name.toLowerCase().endsWith('.pdf')) && (
                                    <div style={{ marginTop: '25px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                                        <h4 style={{ marginBottom: '15px', color: '#e2e8f0' }}>Attached Document</h4>

                                        {/* Preview Section */}
                                        <div style={{ marginBottom: '15px' }}>
                                            {selectedPolicy.file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/) ? (
                                                <img
                                                    src={selectedPolicy.file.url}
                                                    alt="Policy Attachment"
                                                    style={{ maxWidth: '100%', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
                                                />
                                            ) : selectedPolicy.file.name.toLowerCase().endsWith('.pdf') ? (
                                                <div className="pdf-container">
                                                    {pdfLoading && <div className="pdf-loading">Loading document...</div>}
                                                    <div className="pdf-wrapper">
                                                        <div className="pdf-restriction-overlay" title="Download disabled"></div>
                                                        <iframe
                                                            key={selectedPolicy.file.url}
                                                            src={`https://docs.google.com/viewer?url=${encodeURIComponent(selectedPolicy.file.url)}&embedded=true`}
                                                            title="PDF Preview"
                                                            className="pdf-iframe"
                                                            width="100%"
                                                            height="100%"
                                                        >
                                                            <p>Your browser does not support PDFs.</p>
                                                        </iframe>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>

                                        {/* Download disabled */}
                                    </div>
                                )}


                            </>
                        ) : (
                            <div className="no-selection">
                                {loading ? "Loading..." : "Please select a policy from the sidebar to view details."}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PoliciesPage;
